module.exports = __webpack_public_path__ + "static/media/idaho.ecf63b33.jpg";